// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-box[data-v-3285ad80] {\n  text-align: center;\n  padding: 0.208333rem 0;\n}\n.empty-box img[data-v-3285ad80] {\n  width: 1.041667rem;\n  height: 0.625rem;\n}\n.empty-box p[data-v-3285ad80] {\n  font-size: 0.072917rem;\n  font-weight: 400;\n  line-height: normal;\n  color: rgba(0, 0, 0, 0.45);\n}\n.borer-box[data-v-3285ad80] {\n  background: #ffffff;\n  border-radius: 0.052083rem;\n  border: 0.005208rem solid #e0e0e0;\n}", ""]);
// Exports
module.exports = exports;
